"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CredentialsForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _form = require("../form");
var _excluded = ["onSubmit", "submitDisabled", "children", "loginPath"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CredentialsForm = function CredentialsForm(_ref) {
  var onSubmit = _ref.onSubmit,
    submitDisabled = _ref.submitDisabled,
    children = _ref.children,
    loginPath = _ref.loginPath,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(['libCommon', 'libAuth']),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, _extends({
    onSubmit: onSubmit
  }, props, {
    noValidate: true
  }), children, /*#__PURE__*/_react.default.createElement(_form.FormButton, {
    id: "signup-continue",
    disabled: submitDisabled,
    color: "secondary"
  }, t('libCommon:continue'), " \u2192"), /*#__PURE__*/_react.default.createElement(_form.FormLink, {
    id: "login-wallet",
    to: loginPath,
    label: t('libAuth:alreadyHaveAccount')
  }, t('libAuth:login')));
};
exports.CredentialsForm = CredentialsForm;